import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../../reduxService/hooks';
import { conversionLabel } from '../../../conversion';
import { selectProject, selectResults } from '../../selector/conversion';
import { ICommonTabResultsProps } from './ICommonTabResults';
import { selectProjectInfo } from '../../../store/projectInfo/projectInfoSlice';
import { DischargeType } from '../../enum/HydraulicData';

const CommonTabResults = (props: ICommonTabResultsProps) => {
    const { t } = useTranslation();
    const results = useAppSelector(selectResults);
    const project = useAppSelector(selectProject);
    const projectInfo = useAppSelector(selectProjectInfo);
    const general = results.data?.generalResult.general;

    let discharge: string | number = general?.discharge.toFixed(2) ?? 0.0;

    if (project.data?.hydraulicData?.dischargeType == DischargeType.Manual) {
        discharge = results.data ? project.data.hydraulicData.discharge : 0;
    }

    return (
        <div className='tablet-results-tab d-flex justify-content-center gap-5 p-2'>
            <div className='d-flex flex-column'>
                <label className='fw-normal'>{t('tab_results_discharge')}</label>
                <label>
                    <label className='fs-4'>{discharge}</label> {conversionLabel.m3s_ft3s[projectInfo.data?.unitOfMeasure as number]}
                </label>
            </div>
            <div className='d-flex flex-column'>
                <label className='fw-normal'>{t('tab_results_slope')}</label>
                <label>
                    <label className='fs-4'>{general?.longitudinalSlope.toFixed(2) ?? 0.0}</label> %
                </label>
            </div>
            <div className='d-flex flex-column'>
                <label className='fw-normal'>{t('tab_results_depth')}</label>
                <label>
                    <label className='fs-4'>{general?.waterDepth.toFixed(2) ?? 0.0}</label> {conversionLabel.m_ft[projectInfo.data?.unitOfMeasure as number]}
                </label>
            </div>
            <div className='d-flex flex-column'>
                <label className='fw-normal'>{t('tab_results_velocity')}</label>
                <label>
                    <label className='fs-4'>{general?.avarageWaterVelocity.toFixed(2) ?? 0.0}</label> {conversionLabel.ms_fts[projectInfo.data?.unitOfMeasure as number]}
                </label>
            </div>
        </div>
    );
};

export default CommonTabResults;
